export default __webpack_public_path__ + "static/media/gallery-1-2.9e9a4fc4.webp";